import { IContact, IListItem } from '@nkr/models/index';
import { IValidationDetails } from './validation';
import { Button, Col, FormGroup, Panel, Row } from 'react-bootstrap';
import DetailsContent from './details-content';

interface IProps {
    step: number,
    mrn: string,
    email: string,
    surveyInstanceSkip: number,
    phone: string,
    firstName: string,
    lastName: string,
    country: number,
    addressLine1: string,
    city: string,
    state: number,
    nonUsStateProvince: string,
    postalCode: string,
    birthDate: string,
    gender: number,
    donationDate: string,
    heightSubFeet: number,
    heightSubInches: number,
    weightLbs: number,
    coordinatorContactId: number,
    dirty: boolean,
    validation: IValidationDetails,
    coordinatorList: IContact[],
    countryList: IListItem[],
    stateList: IListItem[],
    genderList: IListItem[],
    followUpSurveyInstanceList: IListItem[],
    onFieldChange: (field: string, value: any) => void,
    onPrevious: () => void,
    onSave: () => void
}

const Details = (props: IProps) => {
    return (
        <>
            <Row>
                <Col xs={12} lg={8} lgOffset={2}>
                    <Panel>
                        <Panel.Heading>Step {props.step} - Follow-Up Donor Details</Panel.Heading>
                        <Panel.Body>
                            <DetailsContent
                                mrn={props.mrn}
                                email={props.email}
                                surveyInstanceSkip={props.surveyInstanceSkip}
                                phone={props.phone}
                                firstName={props.firstName}
                                lastName={props.lastName}
                                country={props.country}
                                addressLine1={props.addressLine1}
                                city={props.city}
                                state={props.state}
                                nonUsStateProvince={props.nonUsStateProvince}
                                postalCode={props.postalCode}
                                birthDate={props.birthDate}
                                gender={props.gender}
                                donationDate={props.donationDate}
                                heightSubFeet={props.heightSubFeet}
                                heightSubInches={props.heightSubInches}
                                weightLbs={props.weightLbs}
                                coordinatorContactId={props.coordinatorContactId}
                                dirty={props.dirty}
                                validation={props.validation}
                                coordinatorList={props.coordinatorList}
                                countryList={props.countryList}
                                stateList={props.stateList}
                                genderList={props.genderList}
                                followUpSurveyInstanceList={props.followUpSurveyInstanceList}
                                onFieldChange={props.onFieldChange}
                            />
                        </Panel.Body>
                    </Panel>
                </Col>
            </Row>

            <Row>
                <Col xs={12} lg={8} lgOffset={2}>
                    <FormGroup>
                        <Col xs={12} sm={2}>&nbsp;</Col>
                        <Col xs={12} sm={4}>
                            <Button block onClick={props.onPrevious}>Previous Step</Button>
                        </Col>
                        <Col xs={12} sm={4}>
                            <Button block bsStyle='primary' onClick={props.onSave}>Save</Button>
                        </Col>
                    </FormGroup>
                </Col>
            </Row>
        </>
    );
}

export default Details;